import { useInstanceConfigQuery } from "@certa/queries/hooks/config.hook";
import { get as lodashGet } from "lodash-es";

export const useCanViewTasks = () => {
  const { data: config } = useInstanceConfigQuery();
  return lodashGet(config, "custom_ui_labels.check_user_tasks_access", false);
};
